import { render } from "./GameContainer.vue?vue&type=template&id=2d94d2a8&scoped=true"
const script = {}

import "./GameContainer.vue?vue&type=style&index=0&id=2d94d2a8&scoped=true&lang=scss"

import exportComponent from "/builds/digithia/escape-game/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d94d2a8"]])

export default __exports__